const PILOT_ORIGIN = 'http://localhost:3002';
const EDITOR_ORIGIN = 'https://app.getbee.io';
const LOOPBACK_PERMISSION = `loopback-network ${EDITOR_ORIGIN}`;

// The SDK appends its iframe through this container. Set the permission before
// insertion: changing allow after navigation cannot enable the loaded document.
export const enableBeefreeLocalImages = (
  container,
  enabled = false,
  pageOrigin = typeof window === 'undefined' ? '' : window.location.origin
) => {
  const noop = () => {};
  if (enabled !== true || pageOrigin !== PILOT_ORIGIN || typeof container?.appendChild !== 'function') return noop;

  const originalDescriptor = Object.getOwnPropertyDescriptor(container, 'appendChild');
  if (originalDescriptor && !originalDescriptor.configurable && !originalDescriptor.writable) return noop;
  const originalAppend = container.appendChild;
  const appendWithPermission = function (child) {
    let editorFrame = false;
    if (this === container && child?.tagName === 'IFRAME') {
      try { editorFrame = new URL(child.src).origin === EDITOR_ORIGIN; } catch (_) { /* Ignore an unset or malformed URL. */ }
    }
    if (editorFrame) {
      const directives = (child.getAttribute('allow') || '').split(';').map((value) => value.trim()).filter(Boolean);
      // Replace a previous loopback rule and discard the legacy alias, which
      // grants both loopback and LAN access in current Chromium versions.
      const retained = directives.filter((value) => !['loopback-network', 'local-network-access'].includes(value.split(/\s+/)[0]));
      child.setAttribute('allow', [...retained, LOOPBACK_PERMISSION].join('; '));
    }
    return originalAppend.call(this, child);
  };

  Object.defineProperty(container, 'appendChild', {
    configurable: originalDescriptor ? originalDescriptor.configurable : true,
    enumerable: originalDescriptor ? originalDescriptor.enumerable : false,
    writable: originalDescriptor && 'writable' in originalDescriptor ? originalDescriptor.writable : true,
    value: appendWithPermission
  });

  return () => {
    // Another owner may have replaced the hook while the editor was open.
    if (Object.getOwnPropertyDescriptor(container, 'appendChild')?.value !== appendWithPermission) return;
    if (originalDescriptor) Object.defineProperty(container, 'appendChild', originalDescriptor);
    else delete container.appendChild;
  };
};
